<template>
  <ContentWrap>
    <el-form inline>
      <el-form-item label="店铺">
        <el-select v-model="query.shopId" filterable class="!w-220px">
          <el-option v-for="shop in shops" :key="shop.id" :label="shop.name" :value="shop.id" />
        </el-select>
      </el-form-item>
      <el-button @click="load">查询</el-button>
      <el-button type="primary" @click="openCreate"><Icon icon="ep:plus" />新建团队预订</el-button>
    </el-form>
  </ContentWrap>

  <ContentWrap>
    <el-table v-loading="loading" :data="list">
      <el-table-column prop="teamNo" label="团队单号" width="180" />
      <el-table-column prop="teamName" label="团队名称" min-width="130" />
      <el-table-column prop="contactName" label="联系人" width="100" />
      <el-table-column label="入住进度" width="120">
        <template #default="scope">{{ scope.row.checkedInCount || 0 }}/{{ scope.row.childOrderCount || scope.row.totalRooms || 0 }}</template>
      </el-table-column>
      <el-table-column prop="checkInDate" label="入住" width="110" />
      <el-table-column prop="checkOutDate" label="离店" width="110" />
      <el-table-column prop="totalAmount" label="总金额" width="110" />
      <el-table-column label="状态" width="100"><template #default="scope">{{ statusText(scope.row.status) }}</template></el-table-column>
      <el-table-column label="操作" fixed="right" width="330">
        <template #default="scope">
          <el-button link @click="showDetail(scope.row.id)">详情</el-button>
          <el-button link type="primary" @click="operate(scope.row.id, 'confirm')">确认</el-button>
          <el-button link type="success" @click="operate(scope.row.id, 'check-in')">全部入住</el-button>
          <el-button link type="warning" @click="operate(scope.row.id, 'check-out')">全部退房</el-button>
          <el-button link type="danger" @click="operate(scope.row.id, 'cancel')">取消</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination v-model:page="query.pageNo" v-model:limit="query.pageSize" :total="total" @pagination="load" />
  </ContentWrap>

  <Dialog v-model="createVisible" title="创建团队预订" width="1000px">
    <el-form ref="formRef" :model="form" :rules="rules" label-width="90px">
      <el-row :gutter="12">
        <el-col :span="8"><el-form-item label="团队名称" prop="teamName"><el-input v-model="form.teamName" /></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="联系人" prop="contactName"><el-input v-model="form.contactName" /></el-form-item></el-col>
        <el-col :span="8"><el-form-item label="手机号" prop="contactPhone"><el-input v-model="form.contactPhone" /></el-form-item></el-col>
      </el-row>
      <el-form-item label="入住日期" prop="dates"><el-date-picker v-model="form.dates" type="daterange" value-format="YYYY-MM-DD" /></el-form-item>
      <el-button class="mb-10px" @click="addRoom"><Icon icon="ep:plus" />添加房间</el-button>
      <div v-for="(order, orderIndex) in form.orders" :key="order.key" class="order-block">
        <div class="order-fields">
          <el-select v-model="order.spuId" placeholder="房型"><el-option v-for="spu in spus" :key="spu.id" :label="spu.name" :value="spu.id" /></el-select>
          <el-select v-model="order.roomId" placeholder="房间"><el-option v-for="room in roomsFor(order.spuId)" :key="room.id" :label="room.roomNo" :value="room.id" /></el-select>
          <el-input-number v-model="order.totalPrice" :min="0" :precision="2" controls-position="right" />
          <el-button type="danger" link @click="form.orders.splice(orderIndex, 1)">删除房间</el-button>
        </div>
        <div v-for="(guest, guestIndex) in order.guests" :key="guest.key" class="guest-row">
          <el-input v-model="guest.name" placeholder="入住人姓名" />
          <el-input v-model="guest.phone" placeholder="手机号" />
          <el-select v-model="guest.gender" placeholder="性别"><el-option label="未知" :value="0" /><el-option label="男" :value="1" /><el-option label="女" :value="2" /></el-select>
          <el-input v-model="guest.idNumber" placeholder="证件号码" />
          <el-button link type="danger" :disabled="order.guests.length === 1" @click="order.guests.splice(guestIndex, 1)">删除</el-button>
        </div>
        <el-button link type="primary" @click="addGuest(order)"><Icon icon="ep:plus" />添加入住人</el-button>
      </div>
    </el-form>
    <template #footer><el-button @click="createVisible = false">取消</el-button><el-button type="primary" :loading="saving" @click="submit">创建</el-button></template>
  </Dialog>

  <el-drawer v-model="detailVisible" title="团队子订单" size="820px">
    <el-descriptions :column="3" border class="mb-16px">
      <el-descriptions-item label="团队">{{ detail.team.teamName }}</el-descriptions-item>
      <el-descriptions-item label="联系人">{{ detail.team.contactName }}</el-descriptions-item>
      <el-descriptions-item label="状态">{{ statusText(detail.team.status) }}</el-descriptions-item>
    </el-descriptions>
    <el-table :data="detail.orders">
      <el-table-column prop="orderNo" label="订单号" width="170" />
      <el-table-column prop="roomId" label="房间ID" width="100" />
      <el-table-column label="入住人" min-width="180"><template #default="scope">{{ scope.row.guests?.map((item: any) => item.name).join('、') || scope.row.guestName }}</template></el-table-column>
      <el-table-column label="状态" width="90"><template #default="scope">{{ orderStatusText(scope.row.status) }}</template></el-table-column>
      <el-table-column label="操作" width="190"><template #default="scope"><el-button link @click="guestDrawerRef?.open(scope.row.id)">入住人</el-button><el-button v-if="scope.row.status === 2" link type="success" @click="childOperate(scope.row.id, 'in')">入住</el-button><el-button v-if="scope.row.status === 3" link type="warning" @click="childOperate(scope.row.id, 'out')">退房</el-button></template></el-table-column>
    </el-table>
  </el-drawer>
  <GuestDrawer ref="guestDrawerRef" />
</template>

<script setup lang="ts">
import * as Api from '@/api/hotel/teamBooking'
import * as BookingApi from '@/api/hotel/bookingOrder'
import { getShopSimpleList } from '@/api/hotel/platformShop'
import { getSpuSimpleList } from '@/api/mall/product/spu'
import { listAllRooms } from '@/api/hotel/room'
import GuestDrawer from '@/views/hotel/bookingOrder/GuestDrawer.vue'

defineOptions({ name: 'HotelTeamBooking' })
const message = useMessage()
const shops = ref<any[]>([])
const spus = ref<any[]>([])
const rooms = ref<any[]>([])
const list = ref<any[]>([])
const total = ref(0)
const loading = ref(false)
const saving = ref(false)
const query = reactive({ shopId: undefined as any, pageNo: 1, pageSize: 20 })
const teamStatuses = ['待支付', '已支付', '已确认', '部分入住', '已入住', '已完成', '已取消']
const orderStatuses = ['待支付', '已支付', '已确认', '已入住', '已完成', '已取消']
const statusText = (status: number) => teamStatuses[status] || '未知'
const orderStatusText = (status: number) => orderStatuses[status] || '未知'
const load = async () => { loading.value = true; try { const data = await Api.getPage(query); list.value = data.list; total.value = data.total } finally { loading.value = false } }

const createVisible = ref(false)
const formRef = ref()
const form = reactive<any>({ teamName: '', contactName: '', contactPhone: '', dates: [], orders: [] })
const rules = { teamName: [{ required: true, message: '请输入团队名称' }], contactName: [{ required: true, message: '请输入联系人' }], contactPhone: [{ required: true, message: '请输入手机号' }], dates: [{ required: true, message: '请选择入住日期' }] }
const newGuest = () => ({ key: crypto.randomUUID(), name: '', phone: '', gender: 0, idType: 'ID_CARD', idNumber: '', isPrimary: 0 })
const addGuest = (order: any) => order.guests.push(newGuest())
const addRoom = () => form.orders.push({ key: crypto.randomUUID(), spuId: undefined, roomId: undefined, roomCount: 1, totalPrice: 0, guests: [newGuest()] })
const roomsFor = (spuId: any) => rooms.value.filter((room) => String(room.spuId) === String(spuId))
const openCreate = () => { Object.assign(form, { teamName: '', contactName: '', contactPhone: '', dates: [], orders: [] }); addRoom(); createVisible.value = true }
const submit = async () => {
  await formRef.value?.validate()
  if (!form.orders.length || form.orders.some((order: any) => !order.spuId || !order.roomId || order.guests.some((guest: any) => !guest.name || !guest.phone))) return message.warning('请完整填写房间和入住人信息')
  saving.value = true
  try {
    // 子订单继承主单的店铺与入住/离店日期：后端 @Valid 在 Controller 入口校验子订单，
    // 缺这些字段会直接 400（service 内再覆盖一次，保持一致）
    const orders = form.orders.map((order: any) => ({ ...order, shopId: query.shopId, checkInDate: form.dates[0], checkOutDate: form.dates[1], guestName: order.guests[0].name, guestPhone: order.guests[0].phone, guestCount: order.guests.length, guests: order.guests.map((guest: any, index: number) => ({ ...guest, isPrimary: index === 0 ? 1 : 0 })) }))
    await Api.create({ teamName: form.teamName, shopId: query.shopId, contactName: form.contactName, contactPhone: form.contactPhone, checkInDate: form.dates[0], checkOutDate: form.dates[1], orders })
    message.success('团队预订创建成功'); createVisible.value = false; await load()
  } finally { saving.value = false }
}

const detailVisible = ref(false)
const detail = ref<any>({ team: {}, orders: [] })
const guestDrawerRef = ref<InstanceType<typeof GuestDrawer>>()
const showDetail = async (id: any) => { detail.value = await Api.getDetail(id); detailVisible.value = true }
const operate = async (id: any, type: string) => { await Api.operate(id, type); message.success('操作成功'); await load(); if (detailVisible.value) await showDetail(id) }
const childOperate = async (id: any, type: 'in' | 'out') => { type === 'in' ? await BookingApi.checkIn(id) : await BookingApi.checkOut(id); await showDetail(detail.value.team.id); await load() }
onMounted(async () => { const [shopList, spuList, roomList] = await Promise.all([getShopSimpleList(), getSpuSimpleList(), listAllRooms()]); shops.value = shopList || []; spus.value = spuList || []; rooms.value = Array.isArray(roomList) ? roomList : roomList.list || []; query.shopId = shops.value[0]?.id; await load() })
</script>

<style scoped lang="scss">
.order-block { padding: 12px; margin-bottom: 12px; border: 1px solid var(--el-border-color); border-radius: 4px; }
.order-fields { display: grid; grid-template-columns: 1.5fr 1fr 160px auto; gap: 10px; margin-bottom: 10px; }
.guest-row { display: grid; grid-template-columns: 1fr 1fr 100px 1.5fr 50px; gap: 8px; margin-bottom: 8px; }
</style>
